import qs from 'qs'
import config from '../../config'
import { PASSWORD_CHECK_RULES } from '@/config'
import isElectron from '@/modules/_helpers/isElectron'
import { isEmpty } from 'lodash'

const userResourceUrl = `${config.resourceHost}user`
const tenantResourceUrl = `${config.resourceHost}tenant`
const authResourceUrl = `${config.resourceHost}auth/buhlkonto`
const bankingRescourceUrl = `${config.resourceHost}banking`
const customerResourceUrl = `${config.resourceHost}customer`

const releaseStage = ENV.releaseStage || 'development'

const getBuhlkontoLoginUrl = (params = {}) => {
  if (isElectron()) params.electron = 'true'

  const additionalGetParams = !isEmpty(params) ? `&${qs.stringify(params)}` : ''
  if (releaseStage === 'development') {
    const developmentEnv = {
      'web-dev1.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1060801${additionalGetParams}`,
      'web-dev2.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1060901${additionalGetParams}`,
      'web-dev3.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061001${additionalGetParams}`,
      'web-dev4.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061101${additionalGetParams}`,
      'web-dev5.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061201${additionalGetParams}`,
      'web-dev6.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061301${additionalGetParams}`,
      'web-dev7.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061401${additionalGetParams}`,
      'web-dev8.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061501${additionalGetParams}`,
      'web-dev9.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061601${additionalGetParams}`,
      'web-dev10.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061701${additionalGetParams}`,
      'web-dev11.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061801${additionalGetParams}`,
      'web-dev12.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061901${additionalGetParams}`,
      'web-dev13.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1062001${additionalGetParams}`,
      'web-dev14.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1062101${additionalGetParams}`,
      'web-dev15.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1062201${additionalGetParams}`,
      'web-main.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1062301${additionalGetParams}`,
    }

    if (developmentEnv[location.hostname]) {
      return developmentEnv[location.hostname]
    }
  }

  const env = {
    local: `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1060201${additionalGetParams}`,
    development: `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1060201${additionalGetParams}`,
    test: `https://wpprelive.meinbuero.de/mein-buhlkonto/?buhlparam=1060301${additionalGetParams}`,
    prelive: `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1060401${additionalGetParams}`,
    production: `https://www.meinbuero.de/mein-buhlkonto/?buhlparam=1060101${additionalGetParams}`,
  }
  return env[releaseStage]
}

const getBuhlkontoRegistrationUrl = (params = {}) => {
  if (isElectron()) params.electron = 'true'

  const additionalGetParams = !isEmpty(params) ? `&${qs.stringify(params)}` : ''
  if (releaseStage === 'development') {
    const developmentEnv = {
      'web-dev1.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2060801${additionalGetParams}`,
      'web-dev2.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2060901${additionalGetParams}`,
      'web-dev3.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2061001${additionalGetParams}`,
      'web-dev4.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2061101${additionalGetParams}`,
      'web-dev5.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2061201${additionalGetParams}`,
      'web-dev6.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2061301${additionalGetParams}`,
      'web-dev7.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2061401${additionalGetParams}`,
      'web-dev8.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2061501${additionalGetParams}`,
      'web-dev9.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2061601${additionalGetParams}`,
      'web-dev10.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2061701${additionalGetParams}`,
      'web-dev11.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2061801${additionalGetParams}`,
      'web-dev12.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2061901${additionalGetParams}`,
      'web-dev13.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2062001${additionalGetParams}`,
      'web-dev14.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2062101${additionalGetParams}`,
      'web-dev15.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2062201${additionalGetParams}`,
      'web-main.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2062301${additionalGetParams}`,
    }

    if (developmentEnv[location.hostname]) {
      return developmentEnv[location.hostname]
    }
  }

  const env = {
    local: `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2060201${additionalGetParams}`,
    development: `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2060201${additionalGetParams}`,
    test: `https://wpprelive.meinbuero.de/mein-buhlkonto/?buhlparam=2060301${additionalGetParams}`,
    prelive: `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=2060401${additionalGetParams}`,
    production: `https://www.meinbuero.de/mein-buhlkonto/?buhlparam=2060101${additionalGetParams}`,
  }
  return env[releaseStage]
}

const getBuhlKontoAcceptInvitationUrl = (params = {}) => {
  if (isElectron()) params.electron = 'true'

  const additionalGetParams = !isEmpty(params) ? `&${qs.stringify(params)}` : ''
  if (releaseStage === 'development') {
    const developmentEnv = {
      'web-dev1.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1060801${additionalGetParams}`,
      'web-dev2.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1060901${additionalGetParams}`,
      'web-dev3.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061001${additionalGetParams}`,
      'web-dev4.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061101${additionalGetParams}`,
      'web-dev5.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061201${additionalGetParams}`,
      'web-dev6.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061301${additionalGetParams}`,
      'web-dev7.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061401${additionalGetParams}`,
      'web-dev8.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061501${additionalGetParams}`,
      'web-dev9.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061601${additionalGetParams}`,
      'web-dev10.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061701${additionalGetParams}`,
      'web-dev11.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061801${additionalGetParams}`,
      'web-dev12.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1061901${additionalGetParams}`,
      'web-dev13.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1062001${additionalGetParams}`,
      'web-dev14.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1062101${additionalGetParams}`,
      'web-dev15.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1062201${additionalGetParams}`,
      'web-main.staging.meinbuero.de': `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1062301${additionalGetParams}`,
    }

    if (developmentEnv[location.hostname]) {
      return developmentEnv[location.hostname]
    }
  }

  const env = {
    local: `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1060201${additionalGetParams}`,
    development: `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1060201${additionalGetParams}`,
    test: `https://wpprelive.meinbuero.de/mein-buhlkonto/?buhlparam=1060301${additionalGetParams}`,
    prelive: `https://wptest.meinbuero.de/mein-buhlkonto/?buhlparam=1060401${additionalGetParams}`,
    production: `https://www.meinbuero.de/mein-buhlkonto/?buhlparam=1060101${additionalGetParams}`,
  }
  return env[releaseStage]
}

export const passwordStrengthPatterns = [
  {
    label: 'Mind. 8 Zeichen',
    validate: (value) => value.match(PASSWORD_CHECK_RULES.charsMin8UpperAndLowerOrNumeric) !== null,
  },
  {
    label: 'Mind. 1 Groß- und Kleinbuchstabe',
    validate: (value) => value.match(PASSWORD_CHECK_RULES.charsMin1UpperAndLower) !== null,
  },
  {
    label: 'Mind. 1 Zahl oder Sonderzeichen',
    validate: (value) => value.match(PASSWORD_CHECK_RULES.charsMin1SpecialOrNumeric) !== null,
  },
]

export default {
  login: getBuhlkontoLoginUrl(),
  loginWithParams: getBuhlkontoLoginUrl,
  registration: getBuhlkontoRegistrationUrl(),
  registrationWithParams: getBuhlkontoRegistrationUrl,
  invitation: getBuhlKontoAcceptInvitationUrl,
  endpoints: {
    avvText: `${authResourceUrl}/avv/text`,
    passwordRecover: `${authResourceUrl}/passwordrecover`,
    avvState: `${authResourceUrl}/avv/state`,
    userState: `${userResourceUrl}/self`,
    createTenant: `${tenantResourceUrl}/`,
    demoToAccountRegistration: `${userResourceUrl}/upsertDemoUser`,
    registration: userResourceUrl,
    validateRegistrationData: `${userResourceUrl}/validateRegistrationData`,
    confirmRegistration: `${userResourceUrl}/confirmRegistration`,
    forgotPassword: `${userResourceUrl}/forgotPassword`,
    prepareDelete: `${userResourceUrl}/requestAccountDeletion`,
    changePassword: `${userResourceUrl}/changePassword`,
    changeEmail: `${userResourceUrl}/requestEmailChange`,
    confirmChangeEmail: `${userResourceUrl}/confirmEmailChange`,
    resetPassword: `${userResourceUrl}/resetPassword`,
    acceptInvitation: `${userResourceUrl}/acceptInvitation`,
    resendRegistrationEmail: `${userResourceUrl}/resendRegistrationEmail`,
    acceptAvv: `${userResourceUrl}/acceptAvv`,
    getSubscription: `${config.resourceHost}subscription/state`,
    getSubscriptionHostedPageSession: `${config.resourceHost}chargebee/hosted/page`,
    getSubscriptionPortalSession: `${config.resourceHost}chargebee/portal`,
    getBillingData: `${tenantResourceUrl}/billingData`,
    switch: `${config.resourceHost}tenant/switch`,
    putTenantName: `${config.resourceHost}tenant/name`,
    updateTenantColors: `${config.resourceHost}tenant/colors`,
    postNewTenant: `${config.resourceHost}tenant`,
    getRegistrationConfirmation: `${userResourceUrl}/confirmed`,
    finishOnboarding: `${tenantResourceUrl}/finishOnboarding`,
    checkIban: iban => `${bankingRescourceUrl}/check/iban/${iban}`,
    validateVatNumber: vatNumber => `${customerResourceUrl}/vat/${vatNumber}`,
    trackingInformation: `${config.resourceHost}session/track`,
  },
}
